import React, { PureComponent } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { Helper } from '../helpers/Helper'

const DEFAULT_PREVIEW_WIDTH = 320

export class FormPreviewPane extends PureComponent {
  render() {
    const { config, formData, context } = this.props
    if (!config || !config.component) return null
    const PreviewComponent = Helper.getFormPreviewComponent(config.component)
    if (!PreviewComponent) return null
    const widthValue = (typeof config.width === 'number' && Number.isFinite(config.width) && config.width > 0) ? config.width  : DEFAULT_PREVIEW_WIDTH
    const inlinePaneStyle = {
      flex: `0 0 ${widthValue}px`,
      width: widthValue,
      minWidth: Math.min(widthValue, DEFAULT_PREVIEW_WIDTH),
      maxWidth: widthValue,
    }
    const stickyEnabled = config.sticky !== false
    const paddingBottom = (typeof config.paddingBottom === 'number' && Number.isFinite(config.paddingBottom) && config.paddingBottom > 0)
      ? config.paddingBottom
      : undefined
    const inlineInnerStyle = paddingBottom != null ? { paddingBottom } : undefined
    return (
      <div className={css(Styles.pane)} style={inlinePaneStyle}>
        <div className={css(stickyEnabled ? Styles.sticky : Styles.previewInner)} style={inlineInnerStyle}>
          {config.title ? <div className={css(Styles.title)}>{config.title}</div> : null}
          <div className={css(Styles.body)}>
            <PreviewComponent formData={formData || {}} context={context || {}} />
          </div>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  pane: {
    boxSizing: 'border-box',
    minWidth: 0,
    paddingTop: 4,
    paddingLeft: 8,
    paddingRight: 4,
  },
  sticky: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 24,
    zIndex: 1,
  },
  previewInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 24,
  },
  title: {
    width: '100%',
    fontSize: 15,
    fontWeight: 600,
    color: '#374151',
    marginBottom: 8,
    paddingLeft: 2,
    paddingTop: 2,
    paddingBottom: 6,
    backgroundColor: '#ffffff',
  },
  body: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
})

export default FormPreviewPane
